interface Device { userAgent: string; maxTouchPoints: number }

// Use the original animated battle renderer on every platform.
export function usesIOSSlotPlayback(_fight: any, _device: Device = navigator): boolean {
  return false;
}

export function recordedBattleDuration(fight: any): number {
  const turns = Array.isArray(fight?.fight) ? fight.fight : [];
  const lastTime = turns.reduce((max: number, turn: any) =>
    Number.isFinite(turn.time) && turn.time >= 0 ? Math.max(max, turn.time) : max, 0);
  return Math.max(1000, lastTime * 10 + 500);
}
